var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControllerDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1708_16513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 32,
    height: 32,
    transform: "rotate(-90 0 32)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1708_16513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11.4731C2 10.613 2.31699 9.75235 2.95463 9.0799C4.27492 7.68994 6.47135 7.63451 7.86039 8.95565L16.0243 16.7265L24.1316 8.96357C25.5158 7.63756 27.7122 7.68629 29.0374 9.0726C30.3625 10.4595 30.3132 12.6578 28.9285 13.9838L18.4312 24.0369C17.0927 25.3185 14.9845 25.3209 13.6417 24.0449L3.07875 13.9923C2.36262 13.3083 2 12.3928 2 11.4731Z",
    fill: "#436094"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControllerDown);
export default __webpack_public_path__ + "static/media/controller_down.0e9f690b72ef02354f9b9a76839d562d.svg";
export { ForwardRef as ReactComponent };